import paginator from '@/helpers/paginator';

export default {
  getAllPaginated: async (client_uuid, data = null) =>
    await paginator.grabAllPages($nuxt.$api.host + '/client/' + client_uuid + '/illustrations', {}, data),
  getAll: (client_uuid, data = null) =>
    $nuxt.$axios.get($nuxt.$api.host + '/client/' + client_uuid + '/illustrations', data),
  create: (data) => $nuxt.$axios.post($nuxt.$api.host + '/illustration', data),
  get: (item_uuid) => $nuxt.$axios.get($nuxt.$api.host + '/illustration/' + item_uuid),
  update: (item_uuid, data) => $nuxt.$axios.put($nuxt.$api.host + '/illustration/' + item_uuid, data),
  delete: (item_uuid) => $nuxt.$axios.delete($nuxt.$api.host + '/illustration/' + item_uuid),

  generate: (illustration_uuid) => $nuxt.$axios.post(`${$nuxt.$api.host}/illustration/${illustration_uuid}/generate`),
  proceed: (item_uuid) => $nuxt.$axios.post($nuxt.$api.host + '/illustration/' + item_uuid + '/proceed'),

  getFolder: (illustration_uuid) =>
    $nuxt.$axios.get($nuxt.$api.host + '/illustration/' + illustration_uuid + '/documents'),

  clone: (uuid) => $nuxt.$axios.post($nuxt.$api.host + '/clone/illustration/' + uuid),
};
